import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AccountSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AccountSVG;
